import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Box, CssBaseline, Paper, Snackbar, Grow, Alert } from '@mui/material';
import { setSnackDetails } from '../../service/actions/common';
import DocumentMeta from 'react-document-meta';

const AuthLayout = ({ children }) => {
  const dispatch = useDispatch();
  const snackData = useSelector((state) => state.snackData);
  const metaData = useSelector((state) => state.metaData);
  const handleSnackClose = () => {
    dispatch(setSnackDetails({openState : false, message : ""}));
  }; 

  useEffect(() => {
    // eslint-disable-next-line
  }, []);

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <DocumentMeta {...metaData} />
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={snackData.openState}
        autoHideDuration={6000}
        TransitionComponent={Grow}
        onClose={handleSnackClose}
      >
        <Alert
          onClose={handleSnackClose}
          severity={snackData.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackData.message}
        </Alert>
      </Snackbar>
      <Box
        sx={{
          marginTop: '45%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'          
        }}
      >
        <Paper elevation={3} sx={{ padding: 2, width: '100%', background: '#FDFBFF' }}>
          {children}
        </Paper>
      </Box>
    </Container>
  );
};

export default AuthLayout;
